import { Component, OnInit } from '@angular/core';
import { Invoice } from '../invoice';
import { InvoiceItem } from '../invoiceitem';
import { InvoiceService } from '../invoice.service';
import { ItemService } from '../../item/item.service';

import { Location } from '@angular/common';

import { Vendor } from '../../vendor/vendor';
import { VendorService } from '../../vendor/vendor.service';
import { PoService } from '../../po/po.service';
import { ActivatedRoute, Params } from '@angular/router';
import { UtilityService } from  '../../utility.service';
import { Router} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../auth.service';
import { FileUploadModule } from "ng2-file-upload";  
import { DatepickerOptions } from 'ng2-datepicker';
import {  FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { environment } from '../../environments/environment';
const baseUrl = environment.baseUrl;
const URL = baseUrl+'/api/upload';

@Component({
  selector: 'app-create-invoice',
  templateUrl: './create-invoice.component.html',
  styleUrls: ['./create-invoice.component.css']
})
export class CreateInvoiceComponent implements OnInit {

public uploader: FileUploader;
	authHeader: Array<Headers> = [];
		authToken = '';
  public dateOptions: DatepickerOptions = {
    //this.dateOptions = {
      minYear: 1999,
      maxYear: 2030,
	 
      displayFormat: 'MMM D[,] YYYY',
      barTitleFormat: 'MMMM YYYY',
      dayNamesFormat: 'dd',
      firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
      minDate: new Date(Date.now()), // Minimal selectable date
	  maxDate: new Date(Date.now()),
      //maxDate: new Date(Date.now()),  // Maximal selectable date
      barTitleIfEmpty: 'Click to select a date',
      placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
     // addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
      addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
      fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
      useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
    };

  invoice = new Invoice();
  invoicedata : any = {}
  vendors: Vendor[];
  submitted = false;
  message: string;
   invoicepath:string;
   public itemlist = [];
  po:any ={};
  poitem:any = {};
  deleteditem : any [];
  deletedadditionalitem :any[];
  purchaseorders :any = [];
  invoiceForm: FormGroup;
  poitemarray:any [];
  poitemaddarray:any [];
  public isupdate = false;
  public FormName = "Add a Invoice";
  public AcceptInvoice = "none"
//private fieldArray: Array<{id: number, text: string}>;

  public InvoiceItemArray: Array<InvoiceItem> = [];
  private newAttribute: any = {};
  public InvoiceChrgItemArray: Array<InvoiceItem> = new Array<InvoiceItem>();
  private newChrgAttribute: any = {};
  private invoiceitem: any = {};
//public type MyArrayType = Array<{id: number, text: string}>;

// const arr: fieldArray = [
//   {id: 1, text: 'Sentence 1'},
//   {id: 2, text: 'Sentence 2'},
//   {id: 3, text: 'Sentence 3'},
// ];


  
addFieldValue() {
 this.newAttribute = {};
 this.newAttribute.srno = this.InvoiceItemArray.length+1;
	this.InvoiceItemArray.push(this.newAttribute);
	this.newAttribute = {};
}

 removeFieldValue() {
	
	if(this.InvoiceItemArray.length > 1)
	{
		
		if(this.InvoiceItemArray[this.InvoiceItemArray.length-1].invoiceitemid > 0)
		{
			this.deleteditem.push(this.InvoiceItemArray[this.InvoiceItemArray.length-1].invoiceitemid );
			
		}
		this.InvoiceItemArray.pop();
	}
	this.focusOutFunction();
}

onInputChangedEvent(val: any) {
  if(val.term.length > 0 ){
    this.getItems()
  }
  this.itemlist = [];
}

 getItems() {
  return this.itemService.getItems()
             .subscribe(
              items => {
             //   console.log(items);
                this.itemlist = items
               }
              );
}

addChrgFieldValue() {
  this.newChrgAttribute = {};
 // this.newAttribute.srno = this.InvoiceItemArray.length+1;
   this.InvoiceChrgItemArray.push(this.newChrgAttribute);
   this.newAttribute = {};
 }
 
  removeChrgFieldValue() {
   
   if(this.InvoiceChrgItemArray.length > 0)
   {
     
     if(this.InvoiceChrgItemArray[this.InvoiceChrgItemArray.length-1].invoiceitemid > 0)
     {
       this.deletedadditionalitem.push(this.InvoiceChrgItemArray[this.InvoiceChrgItemArray.length-1].invoiceitemid );
       
     }
     this.InvoiceChrgItemArray.pop();
   }
   this.focusOutFunction();
 }
  
  	
	focusOutFunction()
	{
		this.invoice.totalamount =0;
		this.invoice.totalgst =0;
	
		this.invoice.grandtotal =0;
		if(this.invoice.currencyid < 2)
		{
			for(var i=0; i<this.InvoiceItemArray.length; i++)
			{		
			
				this.InvoiceItemArray[i].totalamount = parseFloat(((this.InvoiceItemArray[i].quantity * this.InvoiceItemArray[i].unitprice) || 0).toFixed(2));
				this.InvoiceItemArray[i].totalgst = parseFloat(((this.InvoiceItemArray[i].totalamount * this.InvoiceItemArray[i].itemgst / 100) || 0 ).toFixed(2) );
				this.InvoiceItemArray[i].grandtotal = parseFloat(((this.InvoiceItemArray[i].totalamount + this.InvoiceItemArray[i].totalgst) || 0).toFixed(2) ) ;
				this.invoice.totalamount += this.InvoiceItemArray[i].totalamount;
				 this.invoice.totalgst += this.InvoiceItemArray[i].totalgst;
			}
			
			for(var i=0; i<this.InvoiceChrgItemArray.length; i++)
			{		
				
					this.InvoiceChrgItemArray[i].totalamount = parseFloat(((this.InvoiceChrgItemArray[i].totalamount * 1) ||0).toFixed(2));
					this.invoice.totalamount += parseFloat((( this.InvoiceChrgItemArray[i].totalamount*1 ) || 0).toFixed(2) );
				
				   this.InvoiceChrgItemArray[i].totalgst =parseFloat(((this.InvoiceChrgItemArray[i].totalamount * this.InvoiceChrgItemArray[i].itemgst / 100) || 0).toFixed(2)  ) ;
					this.InvoiceChrgItemArray[i].grandtotal = parseFloat(( (this.InvoiceChrgItemArray[i].totalamount + this.InvoiceChrgItemArray[i].totalgst ) || 0 ).toFixed(2)) ;
					
						
		  
			
				
					this.invoice.totalgst += (( this.InvoiceChrgItemArray[i].totalgst) || 0);
			}
			this.invoice.totalgst  = parseFloat(this.invoice.totalgst.toFixed(2));
			this.invoice.totalamount  = parseFloat(this.invoice.totalamount.toFixed(2));
			
			this.invoice.grandtotal = ((this.invoice.totalamount + this.invoice.totalgst ));
		}
		else
		{
			
			for(var i=0; i<this.InvoiceItemArray.length; i++)
			{		
			
				this.InvoiceItemArray[i].totalamount = parseFloat(((this.InvoiceItemArray[i].quantity * this.InvoiceItemArray[i].unitprice) || 0).toFixed(2));
				this.InvoiceItemArray[i].totalgst = 0;// parseFloat(((this.InvoiceItemArray[i].totalamount * this.InvoiceItemArray[i].itemgst / 100) || 0 ).toFixed(2) );
				this.InvoiceItemArray[i].grandtotal = parseFloat(((this.InvoiceItemArray[i].totalamount + this.InvoiceItemArray[i].totalgst) || 0).toFixed(2) ) ;
				this.invoice.totalamount += this.InvoiceItemArray[i].totalamount;
				 this.invoice.totalgst += this.InvoiceItemArray[i].totalgst;
			}
			
			for(var i=0; i<this.InvoiceChrgItemArray.length; i++)
			{		
				
					this.InvoiceChrgItemArray[i].totalamount = parseFloat(((this.InvoiceChrgItemArray[i].totalamount * 1) ||0).toFixed(2));
					this.invoice.totalamount += parseFloat((( this.InvoiceChrgItemArray[i].totalamount*1 ) || 0).toFixed(2) );
				
				   this.InvoiceChrgItemArray[i].totalgst =0;//parseFloat(((this.InvoiceChrgItemArray[i].totalamount * this.InvoiceChrgItemArray[i].itemgst / 100) || 0).toFixed(2)  ) ;
					this.InvoiceChrgItemArray[i].grandtotal = parseFloat(( (this.InvoiceChrgItemArray[i].totalamount + this.InvoiceChrgItemArray[i].totalgst ) || 0 ).toFixed(2)) ;
					
						
		  
			
				
					this.invoice.totalgst += (( this.InvoiceChrgItemArray[i].totalgst) || 0);
			}
			this.invoice.totalgst  = parseFloat(this.invoice.totalgst.toFixed(2));
			this.invoice.totalamount  = parseFloat(this.invoice.totalamount.toFixed(2));
			
			this.invoice.grandtotal = ((this.invoice.totalamount + this.invoice.totalgst ));

			
		}
	}
	



//beelow commented code is for deleting the row added by addItem
/*deleteFieldValue(index) {
      this.fieldArray.splice(index, 1);
  }*/


  constructor(
    private invoiceService: InvoiceService,
    private vendorService: VendorService,
    private poService: PoService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder, 
    private util:UtilityService, 
    private router: Router,
    private location: Location,
    private auth: AuthService,
	  private itemService: ItemService,
  ) { }


  OpenInvoice(){
    this.AcceptInvoice='block'; 
   }
  
   closeInvoice(){
    this.AcceptInvoice='none'; 
  }

  onSubmit() {
	  
	 
    this.submitted = true;
    // stop here if form is invalid
    if (this.invoiceForm.invalid) {
        return this.util.showError("Please enter required fields.");		
    }
  else{
    if(this.isupdate){
      this.update();
    }
    else{
      this.OpenInvoice();
	//	this.addInvoice();
    }
  }
}
  addInvoice() {
   // this.submitted = true;
    this.save();
  }

  public onitemChangeObj(itemid,itemIndex){
    console.log(this.itemlist)
    var selecteditem = this.itemlist.filter(items => items.itemid == itemid);	
   	if(selecteditem !=null)
		{
     this.InvoiceItemArray[itemIndex].itemgst =selecteditem[0].gst;
     this.InvoiceItemArray[itemIndex].brandname = selecteditem[0].brandname;
    //  console.log("---"+this.InvoiceItemArray[itemIndex].itemgst)
    }
    this.focusOutFunction();
  }
  
private save(): void {
	
	this.invoice.itemcount =this.InvoiceItemArray.length;
  this.invoice.invoicestatus = 2;
   
  this.invoicedata = this.invoice;

 var date = new Date(this.invoice.invoicedate);
 var newdate = new Date(date);
 //this.invoicedata.invoicedate = newdate.setDate(newdate.getDate() + 1);
  
  this.invoicedata.createdby = this.auth.currentUserValue.userid

  var duedate = new Date(this.invoice.invoicedate);
  var newduedate = new Date(duedate);
  this.invoicedata.invoiceduedate =  newduedate.setDate(newdate.getDate() + 30);
  
  this.invoice.invoiceduedate = this.invoicedata.invoiceduedate
  this.invoiceService.addInvoice(this.invoicedata).subscribe(
    (data :any) => {
      if(data.invoiceid >0){
		  for(var i=0; i<this.InvoiceItemArray.length; i++)
			{
				this.InvoiceItemArray[i].invoiceid = data.invoiceid;
				this.invoiceService.addInvoiceitem(this.InvoiceItemArray[i]).subscribe();
				
				//Update POItem 
				this.poitem = this.po.poitem.filter(items => items.poitemid == this.InvoiceItemArray[i].poitemid)[0];
				this.poitem.quantity = this.poitem.quantity +this.poitem.invoicequantity
				this.poitem.invoicequantity =  this.poitem.invoicequantity + this.InvoiceItemArray[i].quantity;
					
				this.poService.updatePoItem(this.poitem).subscribe();
			}
			
			 for(var i=0; i<this.InvoiceChrgItemArray.length; i++)
			{
				this.InvoiceChrgItemArray[i].invoiceid = data.invoiceid;
				 this.InvoiceChrgItemArray[i].isadditionalcharges = 1;
				this.invoiceService.addInvoiceitem(this.InvoiceChrgItemArray[i]).subscribe();
				this.poitem = this.po.poitem.filter(items => items.poitemid == this.InvoiceChrgItemArray[i].poitemid)[0];
				this.poitem.quantity = parseFloat(this.poitem.quantity) + parseFloat(this.poitem.invoicequantity)
				this.poitem.invoicequantity = this.poitem.invoicequantity + this.InvoiceChrgItemArray[i].quantity ;
				this.poService.updatePoItem(this.poitem).subscribe();
			}
    this.util.showSuccess("Invoice added successfully, Invoice No :- EDIN "+data.invoiceid );
    this.closeInvoice();
	this.router.navigate(['/invoice-list']);//for Redirecting to the list view     
      }
    });
     
}



update(): void {
  //this.submitted = true;
  this.submitted = true;
  this.invoicedata = this.invoice;
  this.invoicedata.modifiedby = this.auth.currentUserValue.userid;
  this.invoicedata.modifiedon = Date.now();
  
  var newdate = new Date(this.invoice.invoicedate);
  this.invoice.invoicedate = newdate;
  //var date = new Date(this.invoice.invoicedate);
  //var newdate = new Date(date);
  this.invoicedata.invoicedate = newdate.setDate(newdate.getDate());

  this.invoiceService.updateInvoice(this.invoicedata)
      .subscribe(() => {
		  //For Invoice Item
				for(var i=0; i<this.InvoiceItemArray.length; i++)
				{
					if(this.InvoiceItemArray[i].invoiceitemid > 0)
					{
					
							this.invoiceService.updateInvoiceitem(this.InvoiceItemArray[i]).subscribe();
					}
					else
					{
						this.InvoiceItemArray[i].invoiceid = this.invoice.invoiceid;
						this.invoiceService.addInvoiceitem(this.InvoiceItemArray[i]).subscribe();
					}
				}
				
				for(var i =0; i< this.deleteditem.length; i++)
				{
					this.invoiceService.deleteInvoiceItem( this.deleteditem[i]).subscribe();
				}
				
				// For Invoice Additional Item
				
			  	for(var i=0; i<this.InvoiceChrgItemArray.length; i++)
				{
					if(this.InvoiceChrgItemArray[i].invoiceitemid > 0)
					{
					
							this.InvoiceChrgItemArray[i].isadditionalcharges = 1;
							this.invoiceService.updateInvoiceitem(this.InvoiceChrgItemArray[i]).subscribe();
					}
					else
					{
						this.InvoiceChrgItemArray[i].invoiceid = this.invoice.invoiceid;
							 this.InvoiceChrgItemArray[i].isadditionalcharges = 1;
						this.invoiceService.addInvoiceitem(this.InvoiceChrgItemArray[i]).subscribe();
					}
				}
				
				for(var i =0; i< this.deletedadditionalitem.length; i++)
				{
					this.invoiceService.deleteInvoiceItem( this.deletedadditionalitem[i]).subscribe();
				}
		  
		  this.util.showSuccess("Invoice update successfully.")
		this.router.navigate(['/invoice-list']);
	  
	  });
     
}

  ngOnInit() {
    // this.invoice.active = 1;
	  	this.authToken = 'Bearer ' + this.auth.currentUserValue.token;
		
	    this.uploader = new FileUploader({url: URL, authTokenHeader : 'Authorization',authToken: this.authToken ,itemAlias: 'photo'});
	    this.uploader.onAfterAddingFile = (file)=> { file.withCredentials = false; };
       //overide the onCompleteItem property of the uploader so we are 
       //able to deal with the server response.
       this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
         
            var response = JSON.parse(response);
            var data = {};
			;
            if(response.error_code==0){
				
				if(response.data.length > 0)
				{
					this.invoice.invoicepath = "uploads/" + response.data;
					//this.uploaddata.userid =0;
					
  }}}
	 
	   //this.getItems();
	 this.deleteditem = new Array();
	 this.deletedadditionalitem = new Array();
	this.newAttribute.srno =1;
	this.InvoiceItemArray.push(this.newAttribute)
	this.newAttribute = {};
	this.newAttribute.srno =2;
	this.InvoiceItemArray.push(this.newAttribute)
	this.newAttribute = {};
    this.newAttribute.srno =3;
	this.InvoiceItemArray.push(this.newAttribute)
    this.getVendors();
    this.GetPOforInvoice();
    //this.addFieldValue();
    if(this.route.snapshot.paramMap.get('invoiceId') != null)
			{
        const invoiceId = +this.route.snapshot.paramMap.get('invoiceId');
				 if(invoiceId > 0)
				 {
					 this.GetInvoicesDetail(invoiceId);
				 }
				 this.isupdate = true;
				 this.FormName = "Update Invoice";				 
			}

    this.invoiceForm = this.formBuilder.group({			
     // vendorid: [this.invoice.vendorid,[Validators.required, Validators.required]],
	  invoicepath: [this.invoice.invoicepath],
      invoicedate: [this.invoice.invoicedate,[Validators.required, Validators.required]],      
      poreference: [this.invoice.poreference,[Validators.required, Validators.required]],
    vendorinvoiceno: [this.invoice.vendorinvoiceno,[Validators.required, Validators.required]],
    // active: [this.invoice.active,[Validators.required, Validators.required]]
    });
  }
  
    GetInvoicesDetail(invoiceid) {   
     this.invoiceService.GetInvoicesDetail(invoiceid)
       .subscribe(invoice => 
	   {this.invoice = invoice;
		if(this.invoice != null)
		{
				//this.InvoiceItemArray = this.invoice.poitem;
					this.InvoiceItemArray = this.invoice.poitem.filter(items => items.isadditionalcharges == 0);
					this.InvoiceChrgItemArray = this.invoice.poitem.filter(items => items.isadditionalcharges == 1);	
					this.purchaseorders.push({poid:this.invoice.poreference,ponumber: this.invoice.ponumber });
					//this.getItems();
				this.focusOutFunction();
		}
	   }
	   );
   }

   // convenience getter for easy access to form fields
get f() {
  return this.invoiceForm.controls
  }

  getVendors() {
    return this.vendorService.getVendors()
               .subscribe(
                vendors => {
                  
                  this.vendors = vendors
                 }
                );
 }
 GetPOforInvoice() {
	 
	if(this.auth.currentUserValue.userroleid !=4)
	  {
			return this.poService.GetPOforInvoice()
             .subscribe(
              purchaseorders => {              
                this.purchaseorders = purchaseorders 
                    
               }
              );
	  }
	  else
	  {
		    return this.poService.GetPOforInvoicePoCreator(this.auth.currentUserValue.userid)
             .subscribe(
              purchaseorders => {              
                this.purchaseorders = purchaseorders 
                    
               }
              );
	  }
}

   
  public onPoChangeObj(poid){
		  return this.poService.GetPOInvoiceDetails(poid)
             .subscribe(
              po => {              
                this.po = po   
				if(this.po != null)
				{
				this.invoice.vendorid = this.po.vendorid;
				this.invoice.vendorname = this.po.vendorname;
				this.invoice.vendoraddress = this.po.vendoraddress;
				this.invoice.vendorphone = this.po.vendoraddress;
				this.invoice.poamount = this.po.grandtotal;
				this.invoice.vendormailid = this.po.vendormailid;
					this.invoice.currencyid = this.po.currencyid
			//	this.InvoiceItemArray = this.po.poitem;
				this.InvoiceItemArray = [];
				this.dateOptions.minDate = new Date(this.po.podate);
				this.poitemarray = this.po.poitem.filter(items => items.isadditionalcharges == 0)
				for(var i=0;  i< this.poitemarray.length; i++)
				{
					this.InvoiceItemArray.push(Object.assign({},this.poitemarray[i]));
				}
				
				this.InvoiceChrgItemArray =[];
				this.poitemaddarray = this.po.poitem.filter(items => items.isadditionalcharges == 1)
				for(var i=0;  i< this.poitemaddarray.length; i++)
				{
					this.InvoiceChrgItemArray.push(Object.assign({},this.poitemaddarray[i]));
				}
				 
				
				this.focusOutFunction();
				}
               }
              );
	}
	


//below function is to restrict special character in input field
omit_special_char(e) {
  var k;
  document.all ? k = e.keyCode : k = e.which;
  return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}

}
